import React, { useEffect, useState, useCallback } from 'react';
import { Button, Badge, Checkbox, Grid, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';

import { CODE_SERVER } from '../../Config';
import axios from 'axios';

import { useSnackbar } from 'notistack';

const Code = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const [gubunRows, setGubunRows] = useState([]);
  const [defaultGubunRows, setDefaultGubunRows] = useState([]);
  const [selectedGubunRows, setSelectedGubunRows] = useState([]);
  const [codeRows, setCodeRows] = useState([]);
  const [defaultCodeRows, setDefaultCodeRows] = useState([]);
  const [selectedCodeRows, setSelectedCodeRows] = useState([]);

  const gubunColumns = [
    {
      field: 'modify',
      headerName: '상태',
      width: 90,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Badge
          badgeContent={params.row.modify}
          color={params.row.modify === 'new' ? 'success' : params.row.modify === 'del' ? 'error' : 'primary'}
          invisible={params.row.modify === ''}
        />
      ),
    },
    {
      field: 'gubun',
      headerName: '코드분류',
      align: 'center',
      headerAlign: 'center',
      width: 160,
      editable: true,
      preProcessEditCellProps: (params) => {
        editGubunCell(params, 'gubun');
      },
    },
    {
      field: 'name',
      headerName: '코드분류명',
      headerAlign: 'center',
      width: 520,
      editable: true,
      preProcessEditCellProps: (params) => {
        editGubunCell(params, 'name');
      },
    },
    {
      field: 'status',
      headerName: '활성화',
      align: 'center',
      headerAlign: 'center',
      width: 120,
      editable: false,
      renderCell: (params) => (
        <Checkbox
          checked={params.row.status}
          disabled={params.row.obj === null}
          onChange={() => handleGubunCodeChange(params)}
        />
      ),
    },
  ];

  const codeColumns = [
    {
      field: 'modify',
      headerName: '상태',
      width: 90,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => (
        <Badge
          badgeContent={params.row.modify}
          color={params.row.modify === 'new' ? 'success' : params.row.modify === 'del' ? 'error' : 'primary'}
          invisible={params.row.modify === ''}
        />
      ),
    },
    {
      field: 'code',
      headerName: '코드',
      align: 'center',
      headerAlign: 'center',
      width: 160,
      editable: true,
      preProcessEditCellProps: (params) => {
        editCodeCell(params, 'code');
      },
    },
    {
      field: 'name',
      headerName: '코드분류명',
      headerAlign: 'center',
      width: 520,
      editable: true,
      preProcessEditCellProps: (params) => {
        editCodeCell(params, 'name');
      },
    },
    {
      field: 'status',
      headerName: '활성화',
      align: 'center',
      headerAlign: 'center',
      width: 120,
      editable: false,
      renderCell: (params) => (
        <Checkbox
          checked={params.row.status}
          disabled={params.row.obj === null}
          onChange={() => handleCodeCodeChange(params)}
        />
      ),
    },
  ];

  function handleCodeCodeChange(params) {
    editCodeCell(params, 'status');
  }
  const onCodeRowsSelectionHandler = (ids) => {
    const selectedRowsData = ids.map((id) => codeRows.find((row) => row.id === id));
    setSelectedCodeRows(selectedRowsData);
  };

  const handleDeleteCodeRow = (rows, deletedRows) => {
    const isSameId = (rows, deletedRows) => rows.id === deletedRows.id;
    const onlyInLeft = (left, right, compareFunction) =>
      left.filter((leftValue) => !right.some((rightValue) => compareFunction(leftValue, rightValue)));

    if (deletedRows[0].modify === 'new') {
      const newRows = onlyInLeft(rows, deletedRows, isSameId);
      setCodeRows(newRows);
    } else {
      const findIndex = codeRows.findIndex((elem) => elem.obj === deletedRows[0].obj);
      let copyRows = [...codeRows];
      if (findIndex !== -1) {
        copyRows[findIndex] = { ...copyRows[findIndex], modify: 'del' };
      }
      setCodeRows(copyRows);
    }
  };

  const createCodeRow = () => {
    return {
      id: codeRows.length + 1,
      obj: null,
      gubun: selectedGubunRows[0]?.gubun ?? '',
      name: '',
      status: true,
      modify: 'new',
    };
  };

  const handleAddCodeRow = () => {
    setCodeRows((prevRows) => [...prevRows, createCodeRow()]);
  };

  const checkCodeRow = (modifyStatus) => codeRows.filter((row) => row.modify === modifyStatus);

  const handdleSaveCodeCode = () => {
    let checkedNewCodeRow = checkCodeRow('new');
    let checkedDelCodeRow = checkCodeRow('del');
    let checkEditCodeRow = checkCodeRow('edit');

    axios
      .post(`${process.env.REACT_APP_SERVER}${CODE_SERVER}/codecode`, {
        newCodeCodes: checkedNewCodeRow,
        delCodeCodes: checkedDelCodeRow,
        editCodeCodes: checkEditCodeRow,
      })
      .then(() => {
        enqueueSnackbar('Code 저장완료.', { variant: 'success', autoHideDuration: 2000 });

        axios
          .get(`${process.env.REACT_APP_SERVER}${CODE_SERVER}/codecode/${selectedGubunRows[0]?.gubun}`)
          .then((res) => {
            let code = [];
            let rows = res.data;
            for (let i = 0; i < rows.length; i++) {
              code.push({
                id: i,
                obj: rows[i]._id,
                gubun: rows[i].gubun,
                code: rows[i].code,
                name: rows[i].name,
                status: rows[i].status,
                modify: '',
              });
            }
            setCodeRows(code);
            setDefaultCodeRows(code);
            setSelectedCodeRows([]);
          });
      });
  };

  const editCodeCell = useCallback(
    (params, field) => {
      const findIndex = codeRows.findIndex((elem) => elem.id === params.row.id);
      if (findIndex === -1) return;
      let copyRows = [...codeRows];
      if (field === 'code') {
        copyRows[findIndex] = {
          ...copyRows[findIndex],
          code: Number(params.props.value),
          modify:
            params.row.modify === 'new'
              ? 'new'
              : defaultCodeRows[findIndex].code === Number(params.props.value)
              ? ''
              : 'edit',
        };
      } else if (field === 'name') {
        copyRows[findIndex] = {
          ...copyRows[findIndex],
          name: params.props.value,
          modify:
            params.row.modify === 'new' ? 'new' : defaultCodeRows[findIndex].name === params.props.value ? '' : 'edit',
        };
      } else if (field === 'status') {
        copyRows[findIndex] = {
          ...copyRows[findIndex],
          status: !params.row.status,
          modify:
            params.row.modify === 'new'
              ? 'new'
              : defaultCodeRows[findIndex].status === !params.row.status
              ? ''
              : 'edit',
        };
      }
      setCodeRows(copyRows);
    },
    [defaultCodeRows, codeRows]
  );

  function handleGubunCodeChange(params) {
    editGubunCell(params, 'status');
  }
  const onRowsSelectionHandler = (ids) => {
    const selectedRowsData = ids.map((id) => gubunRows.find((row) => row.id === id));
    setSelectedGubunRows(selectedRowsData);
  };

  const handleDeleteGubunRow = (rows, deletedRows) => {
    const isSameId = (rows, deletedRows) => rows.id === deletedRows.id;
    const onlyInLeft = (left, right, compareFunction) =>
      left.filter((leftValue) => !right.some((rightValue) => compareFunction(leftValue, rightValue)));

    if (deletedRows[0].modify === 'new') {
      const newRows = onlyInLeft(rows, deletedRows, isSameId);
      setGubunRows(newRows);
    } else {
      const findIndex = gubunRows.findIndex((elem) => elem.obj === deletedRows[0].obj);
      let copyRows = [...gubunRows];
      if (findIndex !== -1) {
        copyRows[findIndex] = { ...copyRows[findIndex], modify: 'del' };
      }
      setGubunRows(copyRows);
    }
  };

  const createGubunRow = () => ({
    id: gubunRows.length + 1,
    obj: null,
    gubun: '',
    name: '',
    status: true,
    modify: 'new',
  });

  const handleAddGubunRow = () => {
    setGubunRows((prevRows) => [...prevRows, createGubunRow()]);
  };

  const checkGubunRow = (modifyStatus) => gubunRows.filter((row) => row.modify === modifyStatus);

  const handdleSaveGubunCode = () => {
    let checkedNewGubunRow = checkGubunRow('new');
    let checkedDelGubunRow = checkGubunRow('del');
    let checkEditGubunRow = checkGubunRow('edit');

    axios
      .post(`${process.env.REACT_APP_SERVER}${CODE_SERVER}/gubuncode`, {
        newGubunCodes: checkedNewGubunRow,
        delGubunCodes: checkedDelGubunRow,
        editGubunCodes: checkEditGubunRow,
      })
      .then(() => {
        enqueueSnackbar('Code 구분 저장완료.', { variant: 'success', autoHideDuration: 2000 });

        axios.get(`${process.env.REACT_APP_SERVER}${CODE_SERVER}/gubuncode`).then((res) => {
          let gubun = [];
          let rows = res.data;
          for (let i = 0; i < rows.length; i++) {
            gubun.push({
              id: i,
              obj: rows[i]._id,
              gubun: rows[i].gubun,
              name: rows[i].name,
              status: rows[i].status,
              modify: '',
            });
          }
          setGubunRows(gubun);
          setDefaultGubunRows(gubun);
        });
      });
  };

  const editGubunCell = useCallback(
    (params, field) => {
      const findIndex = gubunRows.findIndex((elem) => elem.id === params.row.id);
      if (findIndex === -1) return;
      let copyRows = [...gubunRows];
      if (field === 'gubun') {
        copyRows[findIndex] = {
          ...copyRows[findIndex],
          gubun: Number(params.props.value),
          modify:
            params.row.modify === 'new'
              ? 'new'
              : defaultGubunRows[findIndex].gubun === Number(params.props.value)
              ? ''
              : 'edit',
        };
      } else if (field === 'name') {
        copyRows[findIndex] = {
          ...copyRows[findIndex],
          name: params.props.value,
          modify:
            params.row.modify === 'new' ? 'new' : defaultGubunRows[findIndex].name === params.props.value ? '' : 'edit',
        };
      } else if (field === 'status') {
        copyRows[findIndex] = {
          ...copyRows[findIndex],
          status: !params.row.status,
          modify:
            params.row.modify === 'new'
              ? 'new'
              : defaultGubunRows[findIndex].status === !params.row.status
              ? ''
              : 'edit',
        };
      }
      setGubunRows(copyRows);
    },
    [defaultGubunRows, gubunRows]
  );

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_SERVER}${CODE_SERVER}/gubuncode`).then((res) => {
      let gubun = [];
      let rows = res.data;
      for (let i = 0; i < rows.length; i++) {
        gubun.push({
          id: i,
          obj: rows[i]._id,
          gubun: rows[i].gubun,
          name: rows[i].name,
          status: rows[i].status,
          modify: '',
        });
      }
      setGubunRows(gubun);
      setDefaultGubunRows(gubun);
    });
  }, []);

  useEffect(() => {
    if (selectedGubunRows[0]) {
      if (selectedGubunRows[0].gubun !== '') {
        axios
          .get(`${process.env.REACT_APP_SERVER}${CODE_SERVER}/codecode/${selectedGubunRows[0].gubun}`)
          .then((res) => {
            let code = [];
            let rows = res.data;
            for (let i = 0; i < rows.length; i++) {
              code.push({
                id: i,
                obj: rows[i]._id,
                gubun: rows[i].gubun,
                code: rows[i].code,
                name: rows[i].name,
                status: rows[i].status,
                modify: '',
              });
            }
            setCodeRows(code);
            setDefaultCodeRows(code);
            setSelectedCodeRows([]);
          });
      } else {
        setCodeRows([]);
        setDefaultCodeRows([]);
        setSelectedCodeRows([]);
      }
    }
  }, [selectedGubunRows]);

  return (
    <>
      <Grid container direction="row" spacing={4}>
        <Grid size={{ xs: 12 }} sx={{ marginTop: 1, marginBottom: '16px' }}>
          <Typography variant="h5">Code구분(대분류)</Typography>
          <div style={{ marginTop: 4, float: 'right' }}>
            <Button
              color="primary"
              size="small"
              variant="contained"
              component="span"
              onClick={handleAddGubunRow}
              sx={{ margin: '0px 4px 0px 0px', textTransform: 'none' }}
            >
              Add
            </Button>
            <Button
              color="error"
              size="small"
              variant="contained"
              component="span"
              onClick={() => handleDeleteGubunRow(gubunRows, selectedGubunRows)}
              sx={{ margin: '0px 4px 0px 0px', textTransform: 'none' }}
            >
              Del
            </Button>
            <Button
              color="primary"
              size="small"
              variant="contained"
              component="span"
              onClick={handdleSaveGubunCode}
              sx={{ margin: '0px', textTransform: 'none' }}
            >
              Save
            </Button>
          </div>
          <div style={{ minHeight: 400, width: '100%', marginTop: 8 }}>
            <DataGrid
              rows={gubunRows}
              columns={gubunColumns}
              rowHeight={36}
              pageSize={15}
              rowsPerPageOptions={[15]}
              experimentalFeatures={{ newEditingApi: true }}
              onRowSelectionModelChange={(ids) => onRowsSelectionHandler(ids)}
            />
          </div>
        </Grid>

        <Grid item size={{ xs: 12 }} sx={{ height: '660px', width: '100%', marginTop: 1, marginBottom: '16px' }}>
          <Typography variant="h5">Code(소분류)</Typography>
          <div style={{ marginTop: 4, float: 'right' }}>
            <Button
              color="primary"
              size="small"
              variant="contained"
              component="span"
              disabled={selectedGubunRows.length === 0}
              onClick={handleAddCodeRow}
              sx={{ margin: '0px 4px 0px 0px', textTransform: 'none' }}
            >
              Add
            </Button>
            <Button
              color="error"
              size="small"
              variant="contained"
              component="span"
              disabled={selectedGubunRows.length === 0}
              onClick={() => handleDeleteCodeRow(codeRows, selectedCodeRows)}
              sx={{ margin: '0px 4px 0px 0px', textTransform: 'none' }}
            >
              Del
            </Button>
            <Button
              color="primary"
              size="small"
              variant="contained"
              component="span"
              disabled={selectedGubunRows.length === 0}
              onClick={handdleSaveCodeCode}
              sx={{ margin: '0px', textTransform: 'none' }}
            >
              Save
            </Button>
          </div>
          <div style={{ minHeight: 660, width: '100%', marginTop: 8 }}>
            <DataGrid
              rows={codeRows}
              columns={codeColumns}
              rowHeight={36}
              pageSize={15}
              rowsPerPageOptions={[15]}
              experimentalFeatures={{ newEditingApi: true }}
              onRowSelectionModelChange={(ids) => onCodeRowsSelectionHandler(ids)}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default Code;
